import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {configStore} from 'app/store/global';
import SmartSelect from 'app/components/reusable/SmartSelect';

interface SelfExclusionFormState {
    selectedPeriod: string;
    password: string;
}

interface SelfExclusionFormProps {
    onSubmit: (period: string, password: string) => void;
}

export class SelfExclusionForm extends Component<SelfExclusionFormProps, SelfExclusionFormState> {
    state: SelfExclusionFormState = {
        password: '',
        selectedPeriod: configStore.SELF_EXCLUSION_VALUES[0]
    };

    handlePeriodChange = (value: string): void => {
        this.setState({selectedPeriod: value});
    };

    handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const {value} = e.target;
        this.setState({password: value});
    };

    handleSubmit = (e?: React.FormEvent): void => {
        if (e) {
            e.preventDefault();
        }
        this.props.onSubmit(this.state.selectedPeriod, this.state.password);
    };

    getFormData = (): {password: string; period: string} => ({
        password: this.state.password,
        period: this.state.selectedPeriod
    });

    render(): ReactNode {
        return (
            <form className="form-settings" onSubmit={this.handleSubmit}>
                <span className="self-exclusion-content-title">
                    {I18n.t('self_exclusion_title')}
                </span>
                <div
                    className="self-exclusion-content"
                    dangerouslySetInnerHTML={{
                        __html: I18n.t('self_exclusion_content')
                    }}
                />
                <div className="fields-pass-and-exc">
                    <div className="row">
                        <label
                            className="field-label"
                            htmlFor="self_exclusion_period"
                        >
                            {I18n.t('duration_period')}
                        </label>
                        <SmartSelect
                            id="self_exclusion_period"
                            value={this.state.selectedPeriod}
                            onChange={this.handlePeriodChange}
                            collection={configStore.SELF_EXCLUSION_VALUES.map(v => ({
                                text: I18n.t(v),
                                text2: '',
                                value: v
                            }))}
                        />
                    </div>
                    <div className="row">
                        <label
                            className="field-label"
                            htmlFor="self_exclusion_password"
                        >
                            {I18n.t('enter_password')}
                        </label>
                        <input
                            type="password"
                            id="self_exclusion_password"
                            className="field__input"
                            value={this.state.password}
                            onChange={this.handlePasswordChange}
                        />
                    </div>
                </div>
                <div
                    className="fields-pass-and-exc__description"
                    dangerouslySetInnerHTML={{
                        __html: I18n.t(
                            'self_exclusion_message_description',
                            {
                                date: I18n.t(this.state.selectedPeriod)
                            }
                        )
                    }}
                />
            </form>
        );
    }
}

